import { Toaster as Sonner, type ToasterProps } from 'sonner'
import { useTheme } from '@/lib/theme'

export function Toaster(props: ToasterProps) {
  const [pref] = useTheme()
  return (
    <Sonner
      theme={pref}
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'bg-popover! text-popover-foreground! border-border! shadow-lg! rounded-lg!',
          description: 'text-muted-foreground!',
        },
      }}
      {...props}
    />
  )
}
